import type { ComposedOrganization } from '@UI/Providers/CurrentOrganizationProvider/helpers/composeAssignedOrganizations';

/**
 * A union, never a plain derivation: organizations that own a checked
 * facility, plus every organization the user already carries. Dropping the latter would silently
 * remove the user from an organization it belongs to through no facility at all — the normal state
 * of an organization that was just created — since the server only checks an inclusion, not an
 * equality, and would accept the shrunk list. `Set` only dedupes; it never reorders relative to
 * each source's own order.
 */
function deriveOrganizationIds(
	facilityIds: readonly number[],
	organizations: readonly ComposedOrganization[],
	existingOrganizationIds: readonly number[],
): readonly number[] {
	const checkedFacilitiesOrganizationIds = organizations
		.filter((organization) =>
			organization.facilities.some((facility) => facilityIds.includes(facility.id)),
		)
		.map((organization) => organization.id);

	return Array.from(new Set([...checkedFacilitiesOrganizationIds, ...existingOrganizationIds]));
}

export default deriveOrganizationIds;
